import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '@/components/ui/card';
import { getTimeSlotsForDate } from '@/lib/dateUtils';
import { getGroupModeForDate } from '@/lib/groupModeUtils';

const GroupScheduleGrid = ({ schedules, groups, groupModes, selectedDate }) => {
  const getScheduleForGroupAndTime = (group, timeSlot) => {
    const groupSchedules = schedules.filter(s => s.group_name === group && s.time_slot === timeSlot);
    return groupSchedules.length > 0 ? groupSchedules[0] : null;
  };

  const getGroupIcon = (group) => {
    const mode = getGroupModeForDate(groupModes, group, selectedDate);
    if (!mode) return '❔';
    return mode === 'remote' ? '💻' : '🏫';
  };

  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr>
            <th className="p-2 border border-border/50 bg-muted/30 w-24"></th>
            {groups.map((group, index) => (
              <th key={group} className="p-2 border border-border/50 bg-muted/30 min-w-[170px] sm:min-w-[200px]">
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="text-primary font-semibold flex items-center justify-center gap-1"
                >
                  {group}
                  <span>{getGroupIcon(group)}</span>
                </motion.div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {getTimeSlotsForDate(selectedDate).map((timeSlot, rowIndex) => (

            <tr key={timeSlot}>
              <td className="p-2 border border-border/50 bg-muted/30 font-medium text-sm">
                {timeSlot}
              </td>
              
              
              
              
              
              
              {groups.map((group, colIndex) => {
                const schedule = getScheduleForGroupAndTime(group, timeSlot);
                return (
                  <td key={`${group}-${timeSlot}`} className="p-2 border border-border/50">
                    {schedule && (
                      <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: (rowIndex * groups.length + colIndex) * 0.02 }}
                        className="bg-card rounded-md p-2 shadow-sm"
                      >
                        <div className="font-medium text-primary">{schedule.subject}</div>
                        <div className="text-sm text-muted-foreground">{schedule.teacher}</div>
                        {schedule.room && (
                          <div className="text-sm text-muted-foreground">ауд. {schedule.room}</div>
                        )}
                      </motion.div>
                    )}
                  </td>
                );
              })}




            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// ✅ Це правильне місце для експорту
export default React.memo(GroupScheduleGrid);